/**
 * MemberCustomFieldService
 * Member custom field DEFINITIONS for all of CCMS (membermanagement 003).
 * Route: api/member-custom-fields
 * Controller: MemberCustomFieldsController.cs
 *
 * Reading needs member read rights (Admin, HRAdmin, Member.Read, Member.Write or Member.CustomFields.Manage).
 * Creating, editing, ordering and deleting need the Admin role or Member.CustomFields.Manage.
 * A member's values are on MemberService (getMemberCustomFields / setMemberCustomField / removeMemberCustomField).
 */
import { BaseService } from '../base/BaseService';
export class MemberCustomFieldService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? MemberCustomFieldService.DEFAULT_SERVICE_PATH,
            basePath: MemberCustomFieldService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** GET api/member-custom-fields: the definitions in display order. */
    async getAll(options = {}) {
        const url = this.buildUrlWithParams(this.getEndpoint('getAll', ''), {
            includeInactive: options.includeInactive,
            withCounts: options.withCounts,
        });
        const res = await this.http.get(url);
        return res.data ?? [];
    }
    /** GET api/member-custom-fields/types: the field types a member field can have (System catalogue). */
    async getTypes() {
        const res = await this.http.get(this.buildUrl(this.getEndpoint('types', 'types')));
        return res.data ?? [];
    }
    /** GET api/member-custom-fields/{id} (with memberCount). */
    async getById(customFieldId) {
        const res = await this.http.get(this.buildUrl(this.getEndpoint('getById', `${customFieldId}`)));
        if (!res.data)
            throw new Error(`Custom field ${customFieldId} not found`);
        return res.data;
    }
    /** POST api/member-custom-fields. 400 invalid, 409 key taken. */
    async create(data) {
        const res = await this.http.post(this.buildUrl(this.getEndpoint('create', '')), data);
        if (!res.data)
            throw new Error('Failed to add the field');
        return res.data;
    }
    /** PUT api/member-custom-fields/{id}: partial. 409 when the type changes while members have values. */
    async update(customFieldId, data) {
        const res = await this.http.put(this.buildUrl(this.getEndpoint('update', `${customFieldId}`)), data);
        if (!res.data)
            throw new Error('Failed to save the field');
        return res.data;
    }
    /** DELETE api/member-custom-fields/{id}: only while no member has a value (409 otherwise: switch it off). */
    async delete(customFieldId) {
        const res = await this.http.delete(this.buildUrl(this.getEndpoint('delete', `${customFieldId}`)));
        return res.success;
    }
    /** PUT api/member-custom-fields/reorder: the listed fields first (1, 2, 3, ...). Returns every field. */
    async reorder(customFieldIDs) {
        const res = await this.http.put(this.buildUrl(this.getEndpoint('reorder', 'reorder')), { customFieldIDs });
        return res.data ?? [];
    }
}
MemberCustomFieldService.DEFAULT_SERVICE_PATH = 'members';
MemberCustomFieldService.BASE_PATH = 'api/member-custom-fields';
//# sourceMappingURL=MemberCustomFieldService.js.map